import ListingDescription from './ListingDescription'

export default ListingDescription
